"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isNumber = function isNumber(value) {
  if (value === null) return false;
  var regex = /^([0-9]*[.])?[0-9]+$/;
  return regex.test(value.toString());
};

exports.default = isNumber;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/isNumber.js
// module id = 142
// module chunks = 0